import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_COURSE_PROGRESS_REQUEST = 'FETCH_COURSE_PROGRESS_REQUEST';
export const FETCH_COURSE_PROGRESS_SUCCESS = 'FETCH_COURSE_PROGRESS_SUCCESS';
export const FETCH_COURSE_PROGRESS_FAILURE = 'FETCH_COURSE_PROGRESS_FAILURE';

const buildCourseProgressUrl = (groupId) => buildUrl(`/groups/${groupId}/course-progress`);

export function fetchCourseProgressIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildCourseProgressUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchCourseProgress(groupId));
  };
}

export function fetchCourseProgress(groupId) {
  return (dispatch) => {
    const url = buildCourseProgressUrl(groupId);
    const method = 'GET';

    return dispatch(fetchCourseProgressRequest()).payload
      .then((response) => dispatch(fetchCourseProgressSuccess(response)))
      .catch((error) => dispatch(fetchCourseProgressFailure(error)));

    function fetchCourseProgressRequest() {
      return ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchCourseProgressSuccess(courseProgresses) {
      return ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_SUCCESS,
        payload: courseProgresses,
        url,
        method,
        groupId,
      });
    }

    function fetchCourseProgressFailure(error) {
      return ApiCall.createAction({
        type: FETCH_COURSE_PROGRESS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/CourseProgress/actions.js